import { formatChipAmount } from "@/lib/formatting";

interface TotalsBarProps {
  totals: { cashIn: number; chipsBought: number; finalChips: number };
  formatCurrency: (amount: number) => string;
}

export function TotalsBar({ totals, formatCurrency }: TotalsBarProps) {
  return (
    <div className="grid gap-2 text-sm text-muted-foreground md:grid-cols-3">
      <p>Total cash in: {formatCurrency(totals.cashIn)}</p>
      <p>Total chips bought: {formatChipAmount(totals.chipsBought)}</p>
      <p>Total final chips: {formatChipAmount(totals.finalChips)}</p>
    </div>
  );
}
